const getters = {
  backflow: state => state.app.backflow,
  imgBtn: state => state.app.imgBtn,
  jntcImg: state => state.app.jntcImg,
  chosenTime: state => state.app.chosenTime,
  currentPageADInfo: state => state.app.currentPageADInfo,
  currentRouteAdSeat: state => state.app.currentRouteAdSeat,
  pendingBill: state => state.invoice.pendingBill,
  invoiceToken: state => state.invoice.invoiceToken,
  infoAsUserInvoice: state => state.invoice.infoAsUserInvoice,
  invoiceParkId: state => state.invoice.invoiceParkId,
  invoiceInfo: state => state.invoice.invoiceInfo,
  billParams: state => state.transaction.billParams,
  arrearsBill: state => state.transaction.arrearsBill,
  arrearsFSBill: state => state.transaction.arrearsFSBill,
  PayConfig: state => state.transaction.PayConfig,
  token: state => state.user.token,
  cvs: state => state.user.cvs,
  avatar: state => state.user.avatar,
  NBPSS: state => state.user.NBPSS,
  name: state => state.user.name,
  roles: state => state.user.roles,
  wx_portrait: state => state.user.wx_portrait,
  wx_userInfo: state => state.user.wx_userInfo,
  zfb_userInfo: state => state.user.zfb_userInfo,
  wx_token: state => state.user.wx_token,
  CJ_Phone: state => state.user.CJ_Phone,
};
export default getters;
